// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2dRuE","left":"InfoRow_left__1whYT"};